import React, { useEffect } from 'react'
import { Card, CardContent, Grid, Stack } from '@mui/material'
import i18n from 'simple-react-i18n'
import Select from 'components/forms/Select'
import SimpleTextArea from 'components/forms/SimpleTextArea'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import useSandreList from 'utils/customHook/useSandreList'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import PropTypes from 'prop-types'
import { LastUpdate } from 'components/card/LastUpdateCard'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import UserAction from 'administration/components/user/actions/UserAction'

const PGSSEInfos = ({
    readMode,
    diagnostic = {},
    onChangeDiagnostic = () => {},
}) => {
    const dispatch = useDispatch()

    const {
        contributors,
        distributionUnits,
        sectors,
        surveys,
        contacts,
        applicativeUsers,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
        sectors: store.SectorReducer.sectors,
        surveys: store.PgsseReducer.surveys,
        contacts: store.ContactReducer.contacts,
        applicativeUsers: store.UserReducer.applicativeUsers,
    }), shallowEqual)

    const applicativeUsersIds = applicativeUsers.map(u => u.contactCode)
    const availableContacts = contacts.filter(c => !applicativeUsersIds.includes(c.id))
    const campaignStatus = useSandreList(SANDRE.CAMPAGNES_STATUT)

    useEffect(() => {
        if (!applicativeUsers.length) {
            dispatch(UserAction.fetchApplicativeUsers())
        }
    }, [])

    return (
        <Card>
            <CardContent>
                <Grid container columnSpacing={1}>
                    <Grid size={4.5}>
                        <Stack container>
                            <Select
                                options={surveys}
                                label={i18n.pgsse}
                                value={diagnostic.idSurvey}
                                readMode
                                keyLabel='description'
                                keyValue='idSurvey'
                            />
                            <Select
                                options={contributors}
                                label={i18n.collectivity}
                                value={diagnostic.idContributor}
                                readMode
                            />
                            <Select
                                options={sectors}
                                label={i18n.sector}
                                value={diagnostic.idSector}
                                readMode
                            />
                            <Select
                                options={distributionUnits}
                                label={i18n.distributionUnitName}
                                value={diagnostic.idUdi}
                                keyValue='id'
                                readMode
                            />
                        </Stack>
                    </Grid>
                    <Grid size={4.5}>
                        <Stack>
                            <Select
                                options={campaignStatus}
                                label={i18n.state}
                                value={diagnostic.status}
                                onChange={v => onChangeDiagnostic({ status: v })}
                                readMode={readMode}
                            />
                            <SuperMultiAutocomplete
                                options={availableContacts}
                                label={i18n.contributors}
                                values={diagnostic.contributors.split(',').map(d => parseInt(d))}
                                onChange={v => onChangeDiagnostic({ contributors: v.join(',') })}
                                readMode={readMode}
                                multiple
                            />
                            <SimpleTextArea
                                title={i18n.comment}
                                value={diagnostic.comment}
                                onChange={v => onChangeDiagnostic({ comment: v })}
                                rows={2}
                                readMode={readMode}
                            />
                        </Stack>
                    </Grid>
                    <Grid container size={3} justifyContent='end'>
                        <LastUpdate element={diagnostic} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

PGSSEInfos.propTypes = {
    readMode: PropTypes.bool,
    diagnostic: PropTypes.object,
    onChangeDiagnostic: PropTypes.func,
}

export default PGSSEInfos